/**
 * Error codes are i18n keys (ARCHITECTURE §4): the API never returns a human
 * sentence, it returns `{ code, params }` and the client renders
 * `errors.<CODE>` from its catalog. Every code added here MUST also be added
 * to `src/i18n/{sv,en,zh}/common.json` under `errors` — the `satisfies`
 * parity check in `src/i18n/index.ts` keeps the three locales in lockstep and
 * `errorCodes.test.ts` keeps the catalog in lockstep with this list.
 */
export const ERROR_CODES = [
  // generic
  'E_VALIDATION',
  'E_NOT_FOUND',
  'E_CONFLICT',
  'E_INTERNAL',
  'E_RATE_LIMITED',
  // auth / session
  'E_UNAUTHORIZED',
  'E_FORBIDDEN',
  'E_SESSION_EXPIRED',
  'E_SESSION_REVOKED',
  'E_EMS_TOKEN_INVALID',
  'E_EMS_WRONG_SYSTEM',
  'E_USER_INACTIVE',
  // sync / commands
  'E_COMMAND_UNKNOWN',
  'E_COMMAND_FAILED',
  'E_DEVICE_NOT_REGISTERED',
  'E_TASK_ALREADY_CLAIMED',
  'E_STALE_OBSERVATION',
  // warehouse
  'E_STOCK_INSUFFICIENT',
  'E_BIN_BLOCKED',
  'E_BIN_NOT_FOUND',
  'E_PALLET_NOT_FOUND',
  'E_LOT_REQUIRED',
  'E_QTY_INVALID',
  'E_BARCODE_UNKNOWN',
  'E_BARCODE_AMBIGUOUS',
  // orders
  'E_ORDER_BY_CUTOFF',
  'E_ORDER_LOCKED',
  'E_ORDER_NOT_PICKED',
  'E_ARTICLE_NOT_ORDERABLE',
  'E_RESTAURANT_FORBIDDEN',
  // files / printing / erp
  'E_FILE_TOO_LARGE',
  'E_FILE_TYPE',
  'E_UPLOAD_FAILED',
  'E_PRINTER_UNAVAILABLE',
  'E_ERP_UNAVAILABLE',
] as const;

export type ErrorCode = (typeof ERROR_CODES)[number];

export const ERROR_CODE_SET: ReadonlySet<string> = new Set(ERROR_CODES);

export function isErrorCode(value: string): value is ErrorCode {
  return ERROR_CODE_SET.has(value);
}
